<script>
	import { version, is_2nd_store } from '../scripts/util';

	export let layout_class;
	export let developer_mode;
	const this_year = new Date().getFullYear();
	const add_prefix = is_2nd_store ? '-alt' : '';
</script>

<!-- GTag -->
{#if is_2nd_store}
	<script async src="https://www.googletagmanager.com/gtag/js?id=G-DP4K0YQ520"></script>
	<script>
		window.dataLayer = window.dataLayer || [];
		function gtag() {
			dataLayer.push(arguments);
		}
		gtag('js', new Date());

		gtag('config', 'G-DP4K0YQ520');
	</script>
{:else}
	<script async src="https://www.googletagmanager.com/gtag/js?id=G-6PPXKEYPJZ"></script>
	<script>
		window.dataLayer = window.dataLayer || [];
		function gtag() {
			dataLayer.push(arguments);
		}
		gtag('js', new Date());

		gtag('config', 'G-6PPXKEYPJZ');
	</script>
{/if}

<header class="fl p-2 ps-4 bg-white bb b2 border{add_prefix}-primary">
	<h1 class="m-0">
		{#if is_2nd_store}
			<img src="/parts-checker-logo-2-compress.png" alt="パーツチェッカーロゴ" />
		{:else}
			<img src="/parts-checker-logo-compress.png" alt="パーツチェッカーロゴ" />
		{/if}
	</h1>
	{#if is_2nd_store}
		<span class="powered-by ms-3">From 宮関自動車用品店</span>
	{:else}
		<span class="powered-by ms-3">Powered by &copy;World Performance Service.</span>
	{/if}
</header>

<main class={layout_class}>
	<slot />
</main>

<footer class="fl cl">
	{#if is_2nd_store}
		<!-- 宮関自動車用品店 -->
		<a href="https://wps-autoparts.com/">
			<img src="/miya-logo-compress.png" alt="宮関自動車用品店のロゴ" />
		</a>
		<!-- <small class="mt-2">Copyright (C) 2006-{this_year} World Performance Service All Rights Reserved.</small> -->
	{:else}
		<!-- ワールドパフォーマンスサービス -->
		<a href="https://wps-speed.com/">
			<img src="/wps_logo.png" alt="ワールドパフォーマンスサービスのロゴ" />
		</a>
		<small class="mt-2">Copyright (C) 2006-{this_year} World Performance Service All Rights Reserved.</small>
	{/if}

	<span class="version">
		<span>ver.{version}</span>
		{#if developer_mode}
			<span>: Developer</span>
		{/if}
	</span>
</footer>

<style lang="scss" scoped>
	header {
		text-align: left;
		position: relative;
		h1 {
			position: relative;
			font-size: 0rem;
			// a {
			// 	position: absolute;
			// 	height: 100%;
			// 	width: 100%;
			// 	top: 0;
			// 	left: 0;

			// 	// img {
			// 	// }
			// }
		}

		@media (max-width: 1000px) {
			padding-left: 0.5rem !important;

			.powered-by {
				position: absolute;
				right: 0;
				top: 0;
				font-size: 0.6rem;
			}

			h1 {
				img {
					height: 50px;
				}
			}
		}
	}
	main {
		margin: 0.5rem auto 1rem;
		&.home {
			max-width: 800px;
			@media (max-width: 1000px) {
				max-width: 800px;
			}
		}
	}
	footer {
		padding: 0.5rem 0.5rem 1rem;
		position: relative;
		background-color: #222;
		color: #eee;
		text-align: center;
		a {
			color: inherit;
		}
		// small {
		// }
		.version {
			font-size: 0.6rem;
			position: absolute;
			bottom: 1%;
			right: 1%;
		}
		@media (max-width: 1000px) {
			img {
				height: 80px;
			}
		}
	}
</style>
